﻿export function appendTopNode(id) { 

    var element = <HTMLSelectElement>document.getElementById(id);
    if (element)
        document.body.appendChild(element);
}
export function tbsScroll() {
    var rightShw = <HTMLSelectElement>document.getElementById("tbsrightshw");
    var tab = document.querySelector<HTMLElement>('.table-fixed-body');
    var container = document.querySelector<HTMLElement>('.table-container');

    if (tab && rightShw) {
        if (tab.scrollWidth > tab.clientWidth)
            rightShw.style.boxShadow = "-6px 0 6px -4px rgba(0,0,0,.15)";
    }

    if (container.clientWidth > tab.clientWidth) {

        var tbshead = <HTMLSelectElement>document.getElementById("tbs-head");

        if (tbshead)
            tbshead.style.width = "100%";

        var tbsbody = <HTMLSelectElement>document.getElementById("tbs-body");
        if (tbsbody)
            tbsbody.style.width = "100%";
    }

    document.querySelector<HTMLElement>('.table-fixed-body')?.addEventListener('scroll', function (this: HTMLElement) {
        const scrollLeft: number = this.scrollLeft;
        const headerTable: HTMLElement | null = document.querySelector<HTMLElement>('.table-fixed-header table');
        var leftShw = <HTMLSelectElement>document.getElementById("tbsleftshw");
        if (leftShw) {

            if (this.scrollLeft == 0) {
                leftShw.style.boxShadow = "";
            } else {
                leftShw.style.boxShadow = "6px 0 6px -4px rgba(0,0,0,.15)";
            }
        }

        var rightShw = <HTMLSelectElement>document.getElementById("tbsrightshw");
        if (rightShw) {
            if (this.scrollLeft + this.clientWidth >= this.scrollWidth) {
                rightShw.style.boxShadow = "";
            } else {
                rightShw.style.boxShadow = "-6px 0 6px -4px rgba(0,0,0,.15)";
            }
        }

        if (!headerTable) return;

        const fixedList: NodeListOf<HTMLElement> = headerTable.querySelectorAll<HTMLElement>('.tbs-fixed');

        fixedList.forEach((fixedColumn: HTMLElement) => {
            // Check if the column is fixed to left (has left style) or right
            const isLeftFixed: boolean = !!fixedColumn.style.left;

            // Store the original position value
            const originalPosition: string = fixedColumn.style.position;
            const originalOffset: string = isLeftFixed ? fixedColumn.style.left : fixedColumn.style.right;

            // Temporary remove sticky positioning
            fixedColumn.style.position = 'relative';
            if (isLeftFixed) {
                fixedColumn.style.left = 'auto';
            } else {
                fixedColumn.style.right = 'auto';
            }

            // Apply scroll offset to the header
            headerTable.style.transform = `translateX(-${scrollLeft}px)`;

            // Calculate positions
            const tableWidth: number = headerTable.offsetWidth;
            const containerWidth: number = this.offsetWidth;
            const maxScroll: number = tableWidth - containerWidth;
            const effectiveScroll: number = Math.min(scrollLeft, maxScroll);

            // Restore fixed column position
            fixedColumn.style.position = originalPosition || 'sticky';
            if (isLeftFixed) {
                fixedColumn.style.left = originalOffset;
                fixedColumn.style.transform = `translateX(${effectiveScroll}px)`;
            } else {
                fixedColumn.style.right = originalOffset;
                fixedColumn.style.transform = `translateX(${effectiveScroll}px)`;
            }
        });
    });
}
export function getElementPagePosition(element) {
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
    }
    var actualTop = element.offsetTop;
    var current = element.offsetParent;
    while (current !== null) {
        actualTop += (current.offsetTop + current.clientTop);
        current = current.offsetParent;
    }
    return { x: actualLeft, y: actualTop }
}


export function screenChangeListener(dotNetObjectRef, callback) {

    window.addEventListener('resize', (event) => {
        var isfs = isFullscreen();
        dotNetObjectRef.invokeMethodAsync(callback, isfs);
    });
}

export function addPageEventListener(dotNetObjectRef, eventName, callback) {

    window.addEventListener(eventName, (event) => {
        dotNetObjectRef.invokeMethodAsync(callback, eventName, event);
    });
}

export function isFullscreen() {

    return window.innerHeight === window.screen.height
}

export function fullscreen(op) {
    if (op) {
        var docElm = document.documentElement;
        if (docElm.requestFullscreen) {
            docElm.requestFullscreen();
        }
        //else if (docElm.msRequestFullscreen) {
        //    docElm.msRequestFullscreen();
        //}
        //else if (docElm.mozRequestFullScreen) {
        //    docElm.mozRequestFullScreen();
        //}
        //else if (docElm.webkitRequestFullScreen) {
        //    docElm.webkitRequestFullScreen();
        //}

    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        //else if (document.msExitFullscreen) {
        //    document.msExitFullscreen();
        //}
        //else if (document.mozCancelFullScreen) {
        //    document.mozCancelFullScreen();
        //}
        //else if (document.webkitCancelFullScreen) {
        //    document.webkitCancelFullScreen();
        //}
    }
}

export function GoPageTop(top) {

    if (!top)
        top = 0;

    document.documentElement.scrollTop = top;
}

export function scrollToBottom() {
    window.scrollTo(0, document.documentElement.scrollHeight);
}

export function GoPageEnd(wait) {
    if (!wait)
        wait = 200;

    setTimeout(scrollToBottom, wait);
}

export function valueElement(id, val) {
    const element = document.getElementById(id);
    if (element != null)
        (element as HTMLInputElement).value = val;
}

export function selectElement(id) {
    const element = document.getElementById(id);
    if (element != null)
        (element as HTMLInputElement).select();
}

export function focusElement(id) {
    const element = document.getElementById(id);
    if (element != null)
        element.focus();
}

export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 100);
    document.cookie = name + "=0;expires=" + exp.toUTCString() + ";path=/";
}

export function setCookie(cname, cvalue, exdays) {
    var expires = "";
    if (exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString() + ";";
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
}

export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

export function getMultipleSelect(id) {
    var rlst = <HTMLSelectElement>document.getElementById(id);
    var selright = [];

    var idx = 0;
    for (var i = 0; i < rlst.length; i++) {
        var op = rlst.options[i];
        if (op.selected) {
            selright[idx] = op.value;
            idx++;
        }
    }

    return selright;

}

export function msgbox(mess, surl, parent, other) {

    if (mess)
        alert(mess);

    if (surl) {
        if (window.parent && parent)
            window.parent.location = surl;
        else
            window.location = surl;
    }

    if (other) {
        eval(other);
    }

}

let timeoutInvoker = null;
let timeoutHandle = null;

export function initTimeout(invoker, waitt) {

    timeoutInvoker = invoker;
    if (timeoutHandle) {
        clearTimeout(timeoutHandle);
    }
    timeoutHandle = setTimeout(function () {
        timeoutInvoker.invokeMethodAsync('JavascriptTimeout');
    }, waitt);
}

let maskWatting = null;
export function maskWattingShow(op) {

    var mask = document.getElementById("MaskWatting");
    if (mask != null) {

        if (op && mask.style.display != "block" && mask.style.display != "") {
            if (maskWatting) {
                clearTimeout(maskWatting);
                maskWatting = null;
            }

            maskWatting = setTimeout(function () {
                if (mask.style.display != "block" && mask.style.display != "") {
                    mask.style.display = "block";
                    // console.log("block");
                }
                maskWatting = null;
            }, 1000);
        }

        if (!op) {
            try {

                if (maskWatting) {
                    clearTimeout(maskWatting);
                }

                maskWatting = null;
                mask.style.display = "none";

            } catch (error) {
                console.log(error);
                if (maskWatting)
                    clearTimeout(maskWatting);
                mask.style.display = "none";
                maskWatting = null;
            }
        }

    }

}
